import _ from 'lodash';
import { getAppVersion, getAppUrl, isLocalhost } from '../index';
import { isNotValidUserAgent, isBot } from './validateUserAgent';
var IGNORE_LIST = [
    // Wix
    /marketing-header-and-footer/,
    /my-account-header/,
    /wix-style-react/,
    /account\/sites/,
    /https:\/\/cdn-wix.sessionstack.com\/sessionstack.js/,
    /https:\/\/www.wix.com\/undefinedmodule-registry-components.bundle.min.js/,
    /https:\/\/www.wix.com\/dashboard\/(.*)\/revenue-share(.*)/,
    /inbox-header-widget/,
    /notifications-widget-server/,
    /_api\/business-manager\/site\/(.*)\/embeddedServicesWithExpiration/,
    /dealer-react-viewer/,
    /react-module-container/,
    /init-modules-dependencies/,
    /widget-helpers\/install-widget/,
    /contacts-web/,
    /support-chat-widget/,
    /chat-web/,
    /chat/,
    // 3-rd party
    /react-dom/,
    /react-onclickoutside/,
    /googleapis.com/,
    // General
    /extensions\//i,
    /^chrome:\/\//i,
];
var SLED_GUID = 'e1f8841c-16d3-4177-a499-3acd3eae015a';
function isSled(event) {
    return event.user.id === SLED_GUID;
}
function isDevEnv() {
    return process.env.NODE_ENV === 'development';
}
function shouldScreenEvent(event) {
    return (isDevEnv() ||
        isLocalhost() ||
        isBot() ||
        isNotValidUserAgent() ||
        isSled(event));
}
function isBlackListFileError(frames) {
    return !_.isNil(IGNORE_LIST.find(function (source) {
        return source.test(_.get(frames, '0.module', '')) ||
            source.test(_.get(frames, '0.filename', ''));
    }));
}
// Behavior assumed correct based on Sentry code: https://git.io/fp9nq
function getStacktraceFrames(event) {
    var stacktrace = _.get(event, 'exception.values[0].stacktrace', event.stacktrace);
    return _.get(stacktrace, 'frames', []);
}
export default (function (appName) {
    return {
        release: getAppVersion(getAppUrl(appName)),
        blacklistUrls: IGNORE_LIST,
        beforeSend: function (event, hint) {
            if (!shouldScreenEvent(event)) {
                var stacktraceFrames = getStacktraceFrames(event);
                if (_.get(hint, 'originalException.message', '').match(/Network Error/i)) {
                    event.fingerprint = ['Network Error'];
                    event.level = 'info';
                }
                if (_.get(hint, 'originalException.message', '').match(/ChunkLoadError/i)) {
                    event.fingerprint = ['ChunkLoadError'];
                    event.level = 'info';
                }
                if (_.isEmpty(stacktraceFrames)) {
                    event.level = 'info';
                    return null;
                }
                if (isBlackListFileError(stacktraceFrames)) {
                    return null;
                }
                if (_.get(hint, 'originalException.constructor.name', '') ===
                    'UnregisteredComponentUsedError') {
                    // TODO: in progress investigation
                    event.fingerprint = ['UnregisteredComponentUsedError'];
                }
                return event;
            }
        },
    };
});
//# sourceMappingURL=commonConfig.js.map